import Image from 'core/display/Image'
import { signal } from 'services/SignalsService'

export default class BonusImage extends Image {
  constructor(data) {
    super(data)
    this.createSignal()
    this.checkVisibility()
  }

  createSignal() {
    signal.on('STATE:IN:FS-START', this.checkVisibility.bind(this))
  }

  checkVisibility() {
    const data = super.data
    this.alpha = data.freespins == game.models.FreespinModel.get().all ? 1 : 0
  }

}
